import React, { useState, useEffect } from 'react'

const defaultResolutions = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024,
];

const getSrcSet = (src, format = 'jpeg') =>  {
  const [, uuid] = src.replace(/https?:\/\//, '').split('/')
  return defaultResolutions.map(width => {
    return `https://cdn.lineups.io/${uuid}/-/crop/16:9/-/resize/${width}x/-/format/${format}/-/progressive/yes/ ${width}w`
  }).join(', ')
}

const Picture = ({
  aspectRatio,
  sizes,
  formats = ['webp', 'png', 'jpeg'],
  htmlAttributes,
  className,
  ...props
}) => {
  const width = defaultResolutions[defaultResolutions.length - 1]
  const format = 'jpeg'
  const [, uuid] = props.src.replace(/https?:\/\//, '').split('/')
  const src = `https://cdn.lineups.io/${uuid}/-/crop/16:9/-/resize/${width}x/-/format/${format}/-/progressive/yes/`
  
  console.log('hello world')

  return <picture>
    {formats.map(format =>
      <source key={format} sizes={sizes} srcset={getSrcSet(props.src, format)} type={`image/${format}`} />
    )}
    <img className={className} alt={props.alt} {...props} {...htmlAttributes} src={src} />
  </picture>
}

export default Picture
